export const  wordpressUrl = 'https://www.primeskinclinic.in/server/';